import { render, staticRenderFns } from "./UtcDate.vue?vue&type=template&id=20a42298"
import script from "./UtcDate.vue?vue&type=script&setup=true&lang=ts"
export * from "./UtcDate.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports